<template>
  <svg
    ref="data-table-bar-chart"
    class="data-table-bar-chart"
    viewBox="0 0 300 50"
    preserveAspectRatio="xMidYMid meet"
    :style="{ 'font-size': barHeight - 2 }"
  />
</template>

<script>
import * as d3 from "d3";

export default {
  name: "DataTableBarChart",
  props: {
    profile: Object,
  },
  data() {
    return {
      width: 300,
      height: 50,
    };
  },
  computed: {
    barHeight() {
      return (this.height - 6) / 4;
    },
    barSegment() {
      return (this.width - 28) / 100;
    },
  },
  watch: {
    profile: {
      deep: true,
      handler: function () {
        this.generateBars();
      },
    },
  },
  methods: {
    generateBars() {
      const barChart = d3.select(this.$refs["data-table-bar-chart"]);
      barChart.selectAll("*").remove();

      barChart
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", this.barSegment * this.profile.blue)
        .attr("height", this.barHeight)
        .classed("bar", true)
        .classed("blue-fill", true);

      barChart
        .append("text")
        .classed("label", true)
        .attr("x", this.barSegment * this.profile.blue + 2)
        .attr("y", this.barHeight)
        .attr("dy", "-5%")
        .text(`${Math.round(this.profile.blue)}%`);

      barChart
        .append("rect")
        .attr("x", 0)
        .attr("y", this.barHeight)
        .attr("width", this.barSegment * this.profile.green)
        .attr("height", this.barHeight)
        .classed("bar", true)
        .classed("green-fill", true);

      barChart
        .append("text")
        .classed("label", true)
        .attr("x", this.barSegment * this.profile.green + 2)
        .attr("y", this.barHeight * 2)
        .attr("dy", "-5%")
        .text(`${Math.round(this.profile.green)}%`);

      barChart
        .append("rect")
        .attr("x", 0)
        .attr("y", this.barHeight * 2)
        .attr("width", this.barSegment * this.profile.red)
        .attr("height", this.barHeight)
        .classed("bar", true)
        .classed("red-fill", true);

      barChart
        .append("text")
        .classed("label", true)
        .attr("x", this.barSegment * this.profile.red + 2)
        .attr("y", this.barHeight * 3)
        .attr("dy", "-5%")
        .text(`${Math.round(this.profile.red)}%`);

      barChart
        .append("rect")
        .attr("x", 0)
        .attr("y", this.barHeight * 3)
        .attr("width", this.barSegment * this.profile.yellow)
        .attr("height", this.barHeight)
        .classed("bar", true)
        .classed("yellow-fill", true);

      barChart
        .append("text")
        .classed("label", true)
        .attr("x", this.barSegment * this.profile.yellow + 2)
        .attr("y", this.barHeight * 4)
        .attr("dy", "-5%")
        .text(`${Math.round(this.profile.yellow)}%`);

      barChart
        .append("line")
        .classed("axis", true)
        .attr("x1", 0)
        .attr("x2", this.barSegment * 100)
        .attr("y1", this.height - 1)
        .attr("y2", this.height - 1);

      barChart
        .append("line")
        .classed("axis", true)
        .attr("x1", 0)
        .attr("x2", 0)
        .attr("y1", this.height - 4)
        .attr("y2", this.height - 1);

      barChart
        .append("line")
        .classed("axis", true)
        .attr("x1", this.barSegment * 50)
        .attr("x2", this.barSegment * 50)
        .attr("y1", this.height - 4)
        .attr("y2", this.height - 1);

      barChart
        .append("line")
        .classed("axis", true)
        .attr("x1", this.barSegment * 100)
        .attr("x2", this.barSegment * 100)
        .attr("y1", this.height - 4)
        .attr("y2", this.height - 1);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.generateBars();
    });
  },
};
</script>

<style scoped>
.data-table-bar-chart >>> .bar {
  stroke: black;
}
.data-table-bar-chart >>> .axis {
  stroke: black;
  stroke-width: 1px;
}
</style>
